import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Avatar, Paper, Typography } from "@mui/material";
import UpdatePasswordForm from "../../components/auth/UpdatePassword";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  width: 400px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function UpdatePassword() {
  return (
    <React.Fragment>
      <Helmet title="Alpha Plus" />
      <Wrapper>
        <BigAvatar alt="Alpha Plus" src="/static/img/avatars/icon.png" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Update Password
        </Typography>
        <UpdatePasswordForm />
      </Wrapper>
    </React.Fragment>
  );
}

export default UpdatePassword;
